import { defineComponent as _defineComponent } from 'vue'
import { Dogspaces } from '@busy-human/k9-library';
import { computed } from 'vue';

type Props = {
    vax?: Dogspaces.Model['vaccines']
}
type Emits = {
    (e: 'click'): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'vaccine-status',
  props: {
    vax: {}
  },
  emits: ["click"],
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;



const incomplete = computed(() => {
    if(!props.vax) return true;
    if(Object.keys(props.vax).length < 4) return true;
})

const expired = computed(() => {
    if(!props.vax) return true;
    const dates = Object.values(props.vax).map(v => new Date(v.expires));
    const today = new Date().getTime();
    for(const date of dates) {
        if(date.getTime() < today) return true;
    }
    return false;
})

const expiration = computed(() => {
    if(!props.vax) return null;
    const dates = Object.values(props.vax).map(v => new Date(v.expires)).sort((a, b) => a.getTime() - b.getTime());
    return dates[0].toLocaleDateString('default', {year: '2-digit', month: '2-digit', day: '2-digit'})
})


const __returned__ = { props, incomplete, expired, expiration, get Dogspaces() { return Dogspaces }, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})